var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { staticClass: "stepper-wrapper" }, [
    _c(
      "input",
      _vm._b(
        {
          staticClass: "stepper-input form-control",
          class: _vm.inputClass || "input-sm",
          domProps: { value: _vm._innerValue },
          on: {
            input: function($event) {
              return _vm.onChange($event.target.value)
            }
          }
        },
        "input",
        _vm.$attrs,
        false
      )
    ),
    _vm._v(" "),
    _c("div", { staticClass: "stepper-btn-wrap" }, [
      _c("i", {
        staticClass: "stepper-btn-up typcn typcn-arrow-sorted-up p-0",
        attrs: { title: "Increase" },
        on: { click: _vm.increase }
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "stepper-btn-dwn typcn typcn-arrow-sorted-down p-0",
        attrs: { title: "Decrease" },
        on: { click: _vm.decrease }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }